export default __webpack_public_path__ + "ef9f65d91d2b0ba9b2e491e2726e2de1.woff";